import { render, staticRenderFns } from "./SectionHoc.vue?vue&type=template&id=b97a6136&"
import script from "./SectionHoc.vue?vue&type=script&lang=js&"
export * from "./SectionHoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports